module.exports = __webpack_public_path__ + "static/media/185-haiti.85bcd19c.svg";